import { _ as _objectWithoutProperties, b as _slicedToArray, a as _extends, c as _defineProperty, d as _objectSpread2 } from '../_rollupPluginBabelHelpers-b0164b33.js';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Bem from '../packages/honey-bem.js';
import { Injecss } from '../packages/injecss.js';
import '../components/icon.js';
import { Input } from '../components/input.js';
import '../components/spinner.js';
import '../index-c4501d32.js';
import '../_text-621010bc.js';
import { Text } from '../components/text.js';

var styles = {
raw: ".hcr-autocomplete-1-6-0{position:relative}.hcr-autocomplete__dropdown-1-6-0{position:absolute;top:100%;right:0;left:0;z-index:1000}.hcr-autocomplete__dropdown--boxed-1-6-0{top:calc(100% + 6px)}.hcr-autocomplete__list-1-6-0{background:#fff;list-style:none;overflow:auto}.hcr-autocomplete__list--boxed-1-6-0{border-radius:5px;-webkit-box-shadow:0 0 12px rgba(0,0,0,.12);box-shadow:0 0 12px rgba(0,0,0,.12)}.hcr-autocomplete__overflow-cover-1-6-0{display:block;position:absolute;right:0;bottom:0;left:0;height:24px;background-image:-webkit-gradient(linear,left top,left bottom,from(hsla(0,0%,100%,0)),to(#fff));background-image:linear-gradient(180deg,hsla(0,0%,100%,0) 0,#fff);pointer-events:none}.hcr-autocomplete__result-1-6-0{display:block;position:relative;width:100%;padding:6px 12px;border:0;border-bottom:1px solid #e1e1e1;background:transparent;text-align:left;cursor:pointer;-webkit-box-sizing:border-box;box-sizing:border-box}.hcr-autocomplete__result--single-line-1-6-0{padding:12px}.hcr-autocomplete__result-1-6-0:hover{background-color:#f7f7f7}.hcr-autocomplete__list-1-6-0 li:last-child .hcr-autocomplete__result-1-6-0{border:0}.hcr-autocomplete__subtitle-1-6-0,.hcr-autocomplete__title-1-6-0{margin:0;font-family:Roboto Condensed,Arial,sans-serif;font-weight:400;text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.hcr-autocomplete__subtitle-1-6-0{font-size:14px;font-weight:300}",
map:{"hcr-autocomplete":"hcr-autocomplete-1-6-0","hcr-autocomplete__dropdown":"hcr-autocomplete__dropdown-1-6-0","hcr-autocomplete__dropdown--boxed":"hcr-autocomplete__dropdown--boxed-1-6-0","hcr-autocomplete__list":"hcr-autocomplete__list-1-6-0","hcr-autocomplete__list--boxed":"hcr-autocomplete__list--boxed-1-6-0","hcr-autocomplete__overflow-cover":"hcr-autocomplete__overflow-cover-1-6-0","hcr-autocomplete__result":"hcr-autocomplete__result-1-6-0","hcr-autocomplete__result--single-line":"hcr-autocomplete__result--single-line-1-6-0","hcr-autocomplete__title":"hcr-autocomplete__title-1-6-0","hcr-autocomplete__subtitle":"hcr-autocomplete__subtitle-1-6-0"}};

var bem = Bem('autocomplete', styles);
var Autocomplete = function Autocomplete(_ref) {
  var appearance = _ref.appearance,
      resultsToDisplay = _ref.resultsToDisplay,
      debounce = _ref.debounce,
      id = _ref.id,
      resultHasSubtitle = _ref.resultHasSubtitle,
      InlineIcon = _ref.InlineIcon,
      loading = _ref.loading,
      label = _ref.label,
      onDebounce = _ref.onDebounce,
      onSelect = _ref.onSelect,
      onChange = _ref.onChange,
      _ref$results = _ref.results,
      results = _ref$results === void 0 ? [] : _ref$results,
      _ref$resultProps = _ref.resultProps,
      resultProps = _ref$resultProps === void 0 ? {} : _ref$resultProps,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? '' : _ref$value,
      rest = _objectWithoutProperties(_ref, ["appearance", "resultsToDisplay", "debounce", "id", "resultHasSubtitle", "InlineIcon", "loading", "label", "onDebounce", "onSelect", "onChange", "results", "resultProps", "value"]);

  // state setters
  // store timeout for debounce
  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      timer = _useState2[0],
      setTimer = _useState2[1]; // dropdown height


  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      dropHeight = _useState4[0],
      setDropHeight = _useState4[1]; // show/hide overflow gradient cover


  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      hasOverflowCover = _useState6[0],
      hasHasOverflowCover = _useState6[1]; // input value proxy (to allow overwriting)


  var _useState7 = useState(''),
      _useState8 = _slicedToArray(_useState7, 2),
      controlledValue = _useState8[0],
      setControlledValue = _useState8[1]; // height of the result item (button)


  var _useState9 = useState(0),
      _useState10 = _slicedToArray(_useState9, 2),
      resultHeight = _useState10[0],
      setResultHeight = _useState10[1]; // proxies onchange on input (for debounce)
  // fires `onChange` programmatically


  var proxyChange = function proxyChange(event) {
    event.persist();
    var val = event.target.value;
    onChange(event);
    setControlledValue(val);
    if (timer) clearTimeout(timer);
    setTimer(setTimeout(function () {
      return onDebounce(event);
    }, debounce));
  }; // when list scrolls
  // disable overflowCover if reaching end of scroll
  // this avoids the cover being on top the last elements


  var onListScroll = function onListScroll(e) {
    var total = results.length * resultHeight;
    var scrolled = e.target.scrollTop + dropHeight;

    if (total - scrolled < resultHeight) {
      hasHasOverflowCover(false);
    } else {
      hasHasOverflowCover(true);
    }
  }; // overwrite controlled value if prop value changes
  // (allows setting value arbitrarily)


  useEffect(function () {
    setControlledValue(value);
  }, [value]); // show/hide overflow cover depending on results

  useEffect(function () {
    if (resultHeight !== 0 && results && results.length) {
      var targetHeight = resultHeight * results.length;
      var listIsOverflowing = targetHeight > dropHeight;
      hasHasOverflowCover(listIsOverflowing);
    }
  }, [resultHeight, results]); // set dropdown height depending on result height

  useEffect(function () {
    setDropHeight(resultHeight * resultsToDisplay);
  }, [resultsToDisplay, resultHeight]);
  return React.createElement("div", {
    className: bem.b()
  }, React.createElement(Input, _extends({
    id: id,
    onChange: proxyChange,
    label: label,
    value: controlledValue,
    InlineIcon: InlineIcon,
    loading: loading
  }, rest)), results && results.length >= 1 && React.createElement("div", {
    style: {
      maxHeight: "".concat(dropHeight, "px")
    },
    className: bem.e('dropdown', _defineProperty({}, appearance, true))
  }, React.createElement("ul", {
    style: {
      maxHeight: "".concat(dropHeight, "px")
    },
    className: bem.e('list', _defineProperty({}, appearance, true)),
    onScroll: onListScroll
  }, results.map(function (_ref2) {
    var title = _ref2.title,
        subtitle = _ref2.subtitle,
        key = _ref2.key,
        itemRest = _objectWithoutProperties(_ref2, ["title", "subtitle", "key"]);

    return React.createElement("li", {
      key: key || title,
      style: {
        visibility: !dropHeight ? 'hidden' : 'visible'
      }
    }, React.createElement("button", _extends({
      className: bem.e('result', {
        'single-line': !resultHasSubtitle
      }),
      ref: function ref($el) {
        return $el && setResultHeight($el.getBoundingClientRect().height + 1);
      },
      onClick: function onClick() {
        return onSelect(_objectSpread2({
          title: title,
          subtitle: subtitle,
          key: key
        }, itemRest));
      },
      type: "button" // label={title} // @todo buttons don't have labels, clarify why it was in here

    }, resultProps), React.createElement(Text, {
      extraClasses: bem.e('title')
    }, title), resultHasSubtitle && React.createElement(Text, {
      extraClasses: bem.e('subtitle')
    }, subtitle || '')));
  })), hasOverflowCover && React.createElement("span", {
    style: {
      height: resultHeight
    },
    className: bem.e('overflow-cover')
  })));
};
Autocomplete.displayName = 'Autocomplete';
Autocomplete.defaultProps = {
  resultsToDisplay: 3,
  appearance: 'boxed',
  debounce: 300,
  disabled: false,
  resultHasSubtitle: true,
  extraClasses: '',
  InlineIcon: null,
  loading: false,
  onDebounce: function onDebounce() {},
  onSelect: function onSelect() {},
  onChange: function onChange() {},
  results: [],
  resultProps: {},
  value: ''
};
Autocomplete.propTypes = {
  /** Appearance of the dropdown */
  appearance: PropTypes.oneOf(['boxed', 'flat']),

  /** Build in debounce for onChange */
  debounce: PropTypes.number,

  /** disables the autocomplete */
  disabled: PropTypes.bool,

  /** Custom classes name for autocomplete wrapper element */
  extraClasses: PropTypes.string,

  /** Provides label text, required if aria-label is not passed */

  /* eslint-disable react/require-default-props */
  // we want label to be always checked against
  label: function label(_ref3) {
    var ariaLabel = _ref3['aria-label'],
        _label = _ref3.label;
    // if no aria label nor label throw validation error
    return !ariaLabel && !_label ? new Error('Either label or aria label are required') : null;
  },

  /** Provides extra information for this input field */
  info: PropTypes.string,

  /** Icon to be showed in the input field, needs to be an svg inline icon component */
  InlineIcon: PropTypes.func,

  /** Defines element ID that is used to bind it to the label */
  id: PropTypes.string.isRequired,

  /** Displays loading spinner inside input field */
  loading: PropTypes.bool,

  /**
   * Fired when the input value changes (without debounce)
   * to be used only in edge cases, rely on debounce to avoid excessive requests to your API
   * */
  onChange: PropTypes.func,

  /** Fired when the input value changes (with debounce) */
  onDebounce: PropTypes.func,

  /** When a given result is clicked, returns the complete element */
  onSelect: PropTypes.func,

  /** spread on every result button (use for special handling) */
  resultProps: PropTypes.object,

  /** If the results should display the optional "subtitle" field */
  resultHasSubtitle: PropTypes.bool,

  /**
   * Results of autocomplete to be show in dropdown,
   * all extra item props will be returned on select (see onSelect)
   * this allows you to reference them by id (or any other field you need)
  * */
  results: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    key: PropTypes.string
  })),

  /** amount of results to be displayed before overflowing */
  resultsToDisplay: PropTypes.number,

  /** Marks the element as required, adds specified text to label text,
  * e.g. Phone (Mandatory) for required="(Mandatory)" */
  requiredText: PropTypes.string,

  /** Sets HTML input type */
  type: PropTypes.oneOf(['text', 'password', 'search', 'email', 'tel', 'time', 'url']),

  /** Triggers visual validation output */
  valid: PropTypes.bool,

  /** Control the input value  */
  value: PropTypes.string
};
var autocomplete = Injecss(Autocomplete, styles);

export { autocomplete as Autocomplete };
